<template>
    <b-row>
      <b-container class="content">
        <BookingDetails :booking="booking" v-if="booking" />
        <b-card class="pt-10 text-center" v-else>
          <b-aspect aspect="16:9">
            <b-spinner label="Loading..." variant="primary"></b-spinner><br />
            <translate>...loading...</translate>
          </b-aspect>
        </b-card>
      </b-container>
    </b-row>
</template>

<script>
import BookingDetails from './components/booking_details'
import { getBooking } from 'b2b-common/services/api/booking'

export default {
  name: 'BookingView',
  components: { BookingDetails },
  data () {
    return {
      booking: null
    }
  },
  created () {
    const bookingId = this.$route.params.Id
    getBooking({ bookingId }).then(res => {
      this.booking = res
      return res
    })
  }
}
</script>
